module.exports = __webpack_public_path__ + "thumbnail-5e64b9fa095f66801d27fe4197228b2d.png";